module.exports = __webpack_public_path__ + "img/LBC2.c52c2c40.jpg";